import {InputTypes, ValueTypes, IFieldDefinition, FieldViews} from 'app/interfaces';
import { Validators } from '@angular/forms';
import moment from 'moment';
import { IDataContainerService } from 'app/interfaces/data-container.interface';
import { fieldsMap as entityFieldMap} from '../entities/fields';
import { fieldsMap as addressFieldMap} from '../unified_addresses/fields';

const infoFieldsMap: Map<string, IFieldDefinition> = new Map();

entityFieldMap.forEach(function(value, key, map): void{
	value = Object.assign({}, value, { key: value.key });
	infoFieldsMap.set(key, value);
});

// maybe not need cause just entityFieldMap have this
addressFieldMap.forEach(function(value, key, map): void{
	value = Object.assign({}, value, { key: 'primary_address.' + value.key });
	infoFieldsMap.set('primary_address.' + key, value);
});

/*infoFieldsMap.set('description', {
	key: 'description',
	name: 'Descrizione',
	inputType: InputTypes.TINY_MCE,
	valueType: ValueTypes.STRING,
});*/

infoFieldsMap.set('scenario', {
	key: 'scenario',
	name: '',
	inputType: InputTypes.HIDDEN,
	valueType: ValueTypes.STRING,
	fieldView: FieldViews.HIDDEN,
	formValidators: [ Validators.required ],
	defaultValue(dataContainerService: IDataContainerService) {
		return 'info';
	}
});

infoFieldsMap.set('fax', {
	key: 'fax',
	name: 'Fax',
	inputType: InputTypes.TEXT,
	valueType: ValueTypes.STRING
});

infoFieldsMap.set('regime_imposta', {
	key: 'regime_imposta',
	name: 'REG. IMP.',
	inputType: InputTypes.TEXT,
	valueType: ValueTypes.STRING
});

infoFieldsMap.set('capitale_sociale', {
	key: 'capitale_sociale',
	name: 'Cap. Soc.',
	inputType: InputTypes.TEXT,
	valueType: ValueTypes.STRING
});

export {infoFieldsMap};
